<ng-select
  appendTo="body"
  #select
  (close)="select.blur()"
  [ngClass]="{
    invalidInput: mainControl?.invalid && mainControl?.touched,
    styledDropdown: isStyled
  }"
  (scrollToEnd)="loadMoreData()"
  [items]="itemList"
  appearance="outline"
  [bindLabel]="displayKey"
  [bindValue]="valueMapKey"
  placeholder="{{ rootPlaceholderLabel }}{{
    required && rootPlaceholderLabel ? ' *' : ''
  }}"
  [notFoundText]="noEntryLabel"
  [virtualScroll]="true"
  [clearable]="clearable"
  [clearSearchOnAdd]="false"
  (keydown)="onKeyDown($event)"
  [formControl]="mainControl"
  loadingText="Loading..."
  [selectOnTab]="true"
  dropdownPosition="bottom"
  (change)="onValueChange()"
  [readonly]="disabled"
  [searchable]="searchable"
  (search)="onSearchText($event)"
  [multiple]="multiple"
  [closeOnSelect]="!multiple"
>
</ng-select>
<mat-error class="custom-mat-error" *ngIf="isRequired()"
  >*Please select this required field
</mat-error>
